/**
 * @file
 *
 * JS behaviors for a modal.
 */
(function ($, Drupal) {
  Drupal.behaviors.modal = {
    attach: function (context, settings) {
      $(".modal", context)
        .once("modalBehavior")
        .each(function () {
          // Attach event to the bootstrap modal hide event.
          $(this).on("hide.bs.modal", function (e) {
            // Make contained video stop playing by replacing the src attribute.
            $(this)
              .find("iframe")
              .each(function () {
                let $iframe = $(this);
                // Get src attribute of the iframe.
                let src = $iframe.attr("src");

                if (src) {
                  // Reset the source attribute. This will cause any iframe video to stop playing.
                  $iframe.attr("src", src);
                }
              });
          });
        });
    },
  };
})(jQuery, Drupal);
